import { AdminDashboard } from '@unistocks/features/admin/admin-dashboard';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function AdminIndexPage() {
  return (
    <>
      <Head>
        <title>{t('::Menu:Administration')}</title>
      </Head>
      <AdminDashboard />
    </>
  );
}
